<template>
  <v-btn icon :color="color" @click="doHandlerClick()">
    <v-icon medium>{{iconCls}}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "RyouAddBtn",
  props: {
    color: {
      type: String,
      required: false,
      default: "#3949AB"
    },
    iconCls: {
      type: String,
      required: false,
      default: "mdi-plus"
    },
    handlerClick: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  methods: {
    doHandlerClick() {
      this.handlerClick();
    }
  },
  computed: {}
};
</script>

<style scoped>
</style>
